import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  addComplaintComment,
  ComplaintSeverity,
  ComplaintStatus,
  getAllComplaints,
  getComplaintSummary,
  updateComplaint,
} from "services/complaint.service";

export default function useComplaints(params?: {
  page?: number;
  limit?: number;
  status?: string;
  severity?: string;
  unassigned?: boolean;
}) {
  return useQuery(["complaints", params], () => getAllComplaints(params), {
    keepPreviousData: true,
  });
}

export function useComplaintSummary() {
  return useQuery("complaint-summary", getComplaintSummary);
}

/**
 * Both mutations invalidate the summary as well as the list — the counts at
 * the top of the page are the reason to open it, and a stale "3 unassigned"
 * after you have just taken one is worse than no count at all.
 */
export function useUpdateComplaint() {
  const queryClient = useQueryClient();

  return useMutation(
    ({
      id,
      ...data
    }: {
      id: string;
      status?: ComplaintStatus;
      severity?: ComplaintSeverity;
      resolution?: string;
    }) => updateComplaint(id, data),
    {
      onSuccess() {
        queryClient.invalidateQueries("complaints");
        queryClient.invalidateQueries("complaint-summary");
      },
    }
  );
}

export function useAddComplaintComment() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, body }: { id: string; body: string }) => addComplaintComment(id, body),
    {
      onSuccess() {
        queryClient.invalidateQueries("complaints");
      },
    }
  );
}
